var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('main',_vm._l((_vm.data.page.sections),function(section){return _c('Section',{key:section.id,attrs:{"data":section}},[(section.title == 'Hit me up')?_c('Form'):_vm._e()],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }